// extracted by mini-css-extract-plugin
module.exports = {"text":"LoginInput_text__3Z97I FormField_text__3CRh7 font_normal__3xTtI","icon":"LoginInput_icon__1pd08"};